const get_started = {
    page_title: '开始上手',
    title: '成功开发身份方案，我们先来探索一番',
    subtitle: '一些你可以做的事情，以快速获取 Logto 的价值',
    develop: {
        title: '开发：花 5 分钟集成你的应用',
        title_cloud: 'Develop: 安全地在几分钟内集成您的应用',
        subtitle_cloud: '或花 5 分钟用我们预构建的 SDK 和教程集成您的应用。',
        try_mcp: '试试用 MCP 一句话完成集成',
    },
    customize: {
        title: '自定义：提供出色的登录体验',
        preview: {
            title: '实时预览定制的登录体验',
            subtitle: '立刻尝试 Logto 登录体验，看看它是如何工作的',
        },
        connector: {
            title: '添加更多连接器来支持更多社交登录方式',
            subtitle: '尝试免密码登录，为您的客户提供安全、无摩擦的体验',
        },
        continue_customizing: '继续定制',
        try_now: '立即尝试',
        add_more: '添加更多',
    },
    secure: {
        title: '安全：保护你的资源',
    },
    manage: {
        title: '管理：为你的产品和用户定义访问控制',
        rbac: {
            title: '为你的资源添加基于角色的访问控制',
            subtitle: '通过可扩展的角色授权控制你的资源，应对不同的使用场景。',
        },
        create_roles: '创建角色',
    },
    convert_to_production: {
        card_title: '准备上线了吗？别忘了启动你的生产环境设置！',
        title: '不要让你的项目停留在开发模式',
        subtitle: '你正在使用开发租户进行免费测试。要上线，请创建或转换为生产租户。需要自定义内容？<a>联系我们</a>',
        convert_button: '转换为生产租户',
    },
    oss_cloud: {
        try: {
            title: '跳过运维工作，免费试用 Logto Cloud',
            badge: '推荐',
            description: '获得一个无需维护的全托管 Logto，同时享受 MCP 驱动的快速集成、多租户支持、团队协作以及全部高级功能。可免费开始，无需信用卡。',
            action: '探索 Logto Cloud',
        },
        private_cloud: {
            title: '需要合规支持或定制部署？',
            card_title: '私有云',
            description: '获得一个专属的 Logto 实例，具备完整的数据隔离、自定义域名和 SLA 保障。非常适合对数据驻留或合规有严格要求的企业。基础设施由我们负责，你可以专注于产品本身。',
        },
    },
    view_all: '查看全部 →',
};
export default Object.freeze(get_started);
